/**
 * @since 7.1.0
 */
export interface EventGuest {
  /**
   * @since 7.1.0
   */
  name?: string;
  /**
   * @since 7.1.0
   */
  email: string;
}
